import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';

import { take } from 'rxjs/operators';

import { AuthService } from '@auth/services';

@Component({
  templateUrl: './server-error.component.html',
  styleUrls: ['./server-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServerErrorComponent {
  constructor(public authService: AuthService, private router: Router) {}

  goBack() {
    this.authService.screens$.pipe(take(1)).subscribe((screens) => {
      void this.router.navigate([screens?.currentScreen?.route ?? 'home']);
    });
  }

  goHome() {
    void this.router.navigate(['home']);
  }
}
